<section>
    <h1 class="fs-2 text-center mt-4">Our Leadership</h1>
    <div class="bg-light pt-5 pb-5">
        <div class="container px-5">
            <div class="row g-0" *ngIf="employee">
                <div class="col-md-3">
                    <div class="profile-image rounded-4">
                        <!-- Profile Picture Binding -->
                        <img class="img-fluid rounded-4 w-100 h-100" itemprop="image" [src]="getImageUrl(employee.profilePicture)" alt="{{ employee.firstName }} {{ employee.lastName }}">
                    </div>
                </div>
                <div class="col-md-9 mt-5 px-5 pt-4 pb-4 profile-details rounded-bottom rounded-top">
                    <!-- Name Binding -->
                    <h1 class="pt-3">{{ employee.firstName }} {{ employee.lastName }}</h1>
                    
                    <!-- Designation Binding -->
                    <!-- <p>
                        <span class="text-secondary">Designation:</span>
                        <span class="px-3">{{ employee.experienceDetails.designationName || 'Not available' }}</span>
                    </p> -->
                    
                    <!-- Email Binding -->
                    <p>
                        <span class="text-secondary">Email:</span>
                        <span class="px-3" style="word-break: break-all;">{{ employee.email }}</span>
                    </p>
                    
                    <!-- Phone Binding -->
                    <p>
                        <span class="text-secondary">Phone:</span>
                        <span class="px-3">{{ employee.mobile || 'Not available' }}</span>
                    </p>
                    
                    <!-- Experience (Years) Binding -->
                    <p>
                        <span class="text-secondary">Experience:</span>
                        <span class="px-3">{{ employee.experience }} Years</span>
                    </p>
            
                    <!-- Social Links Binding (if they exist) -->
                    <div class="social-icons">
                        <a *ngIf="employee.linkedInLink" [href]="employee.linkedInLink"><i class="fab fa-fw fa-linkedin fa-2x"></i></a>
                        <a *ngIf="employee.twitterLink" [href]="employee.twitterLink"><i class="fab fa-fw fa-twitter fa-2x"></i></a>
                        <a *ngIf="employee.facebookLink" [href]="employee.facebookLink"><i class="fab fa-fw fa-facebook fa-2x"></i></a>
                        <a *ngIf="employee.instagramLink" [href]="employee.instagramLink"><i class="fab fa-fw fa-instagram fa-2x"></i></a>
                        <!-- Add other social links similarly -->
                    </div>
                </div>
            </div>
            
            <!-- If employee data is not available -->
            <p *ngIf="!employee"><span class="loader"></span>
            </p>
            
        </div>
    </div>
</section>

<section class="mt-5">
    <div class="container-fluid px-5">
        <div class="row px-sm-0 px-md-5 px-lg-5" *ngIf="employee">
            <div class="col-md-6 ">
                <mat-card appearance="outlined" class="h-100">
                    <mat-card-content>
                        <div class="d-flex bg-icon-color-about">
                            <img class="img-fluid  h-100 px-4" src="../../../assets/images/svg/clipboard-user.svg"  alt="About_icon">
                            <h1 class="ms-4 pt-4">About</h1>
                        </div>
                        <p class="pt-4" [innerHTML]="employee.editorContent"></p>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="col-md-6">
                <mat-card appearance="outlined">
                    <mat-card-content>
                        <div class="d-flex bg-icon-color-achievements">
                            <img class="img-fluid h-100 px-4" src="../../../assets/images/svg/membershipprofile.svg"  alt="About_icon">
                            <h1 class="ms-4 pt-4">Achievements</h1>
                        </div>
                        <ul>
                            <li class="pt-4" *ngFor="let achievement of employee?.achievements">
                                <b>{{ achievement.title }}:</b> {{ achievement.description }}
                            </li>
                        </ul>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</section>

<section class="mt-4 px-5 pb-5">
    <div class="container-fluid px-sm-0 px-md-5 px-lg-5">
        <mat-card appearance="outlined">
            <mat-card-content>
                <h1>Work Experience</h1>
                <div class="row" >
                    <div class="col-md-6" *ngFor="let experience of employee?.experienceDetails">
                        <mat-card appearance="outlined">
                            <mat-card-content>
                                <div class="d-flex">
                                    <div class="bg-icon-color-experience">
                                        <img class="img-fluid h-100 px-sm-3 px-md-3 px-lg-4" src="../../../assets/images/svg/briefcase.svg"  alt="experience_icon">
                                    </div>
                                    <div class="p-2">
                                        <h3>{{ experience.companyName }}</h3>
                                        <div class="d-flex">
                                            <p>{{ experience.designationName }}</p>
                                            <p class="px-3">{{ experience.startDate | date:'MMM YYYY' }} {{ experience.endDate | date:'MMM YYYY'}} </p>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</section>